import type { AdminCrewReportOverviewMetricsProps } from "../../models/admin-crew-report.models";
import { ADMIN_CREW_REPORT_STATISTICS_VIEW_LABELS } from "../../utils/admin-crew-report.constants";
import AdminCrewReportMetricCard from "./AdminCrewReportMetricCard";

const AdminCrewReportOverviewMetrics = ({ statistics, view }: AdminCrewReportOverviewMetricsProps) => {
  const viewLabels = ADMIN_CREW_REPORT_STATISTICS_VIEW_LABELS[view];

  return (
    <section
      aria-label={viewLabels.overviewAriaLabel}
      data-test="admin-crew-report-overview-metrics"
      data-testid="admin-crew-report-overview-metrics"
      className="grid h-[250px] w-full min-w-0 grid-cols-2 grid-rows-2 gap-4 justify-self-start md:col-start-1 md:row-start-2 md:max-w-sm xl:col-start-3 xl:row-start-2 xl:ml-[min(0px,calc(24rem_-_100%))] xl:w-[max(100%,calc(200%_-_24rem))] xl:max-w-none"
    >
      <AdminCrewReportMetricCard
        title="Average Contract Duration"
        value={statistics.averageContractDurationMonths}
        unit="months"
        fractionDigits={1}
        dataTestId="admin-crew-report-average-contract-duration"
      />
      <AdminCrewReportMetricCard
        title="Average Months On Board"
        value={statistics.averageMonthsOnBoard}
        unit="months"
        fractionDigits={1}
        dataTestId="admin-crew-report-average-months-on-board"
      />
      <AdminCrewReportMetricCard
        title={viewLabels.totalPeopleTitle}
        value={statistics.totalCrewOnBoard}
        unit={viewLabels.totalPeopleUnit}
        fractionDigits={0}
        dataTestId="admin-crew-report-total-crew-on-board"
      />
      <AdminCrewReportMetricCard
        title={viewLabels.totalRunningVesselsTitle}
        value={statistics.totalRunningVessels}
        unit="vessels"
        fractionDigits={0}
        dataTestId="admin-crew-report-total-running-vessels"
      />
    </section>
  );
};

export default AdminCrewReportOverviewMetrics;
